/**
 * Function to check if an element is in the viewport.
 * It calculates whether the specified element is within a certain percentage of the viewport height from the top.
 *
 * @param {Element} element - The target element to check for visibility in the viewport.
 *
 * @param {number} [percentageFromTop=0] - The percentage of the viewport height from the top at which to consider
 *                                         the element in the viewport. Defaults to 0.
 *
 * @returns {boolean} True if the element is in the viewport within the specified percentage from the top, otherwise false.
 */
const isInViewport = (element, percentageFromTop = 0) => {
  
  try {
	
	// Check if the element parameter is not provided
	if (!element) {
	  throw new Error('Element parameter is required.');
	}
	
	const rect = element.getBoundingClientRect();
	const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	const topThreshold = (percentageFromTop / 100) * viewportHeight;
	
	// Check if the top of the element is within the specified percentage from the top of the viewport
	const topInView = rect.top <= topThreshold;
	
	// Check if the bottom of the element is within the same percentage from the top of the viewport
	const bottomInView = rect.bottom >= topThreshold;
	
	return topInView && bottomInView;
	
  } catch (error) {
	
	// Handle the error
	console.error('An error occurred in isInViewport:', error.message);
	
  }
  
};

export default isInViewport;